<template>
<m-pageframe
    title="Start Conversation"
>
<v-container
    v-if="customer != null"
>

    <h2>Select customer's phone number to text</h2>

    <div
        v-if="customer.customer_phone_numbers.length == 0"
    >
        This customer does not have any phone numbers, so you may not start a conversation.
    </div>

    <div
        v-else
    >
        <v-list-item
            v-for="(number, index) in customer.customer_phone_numbers"
            :key="index"
        >
            <v-list-item-avatar>
                <v-icon>mdi-message-text-outline</v-icon>
            </v-list-item-avatar>

            <v-list-item-content
                v-on:click="onClickPhoneNumber(customer, number)"
                style="cursor: pointer"
            >
                <v-list-item-title>Text {{customer.customer_name}} at {{$rc.pretty(number,'endpoint')}}</v-list-item-title>
            </v-list-item-content>

            <v-btn
                color="primary"
                v-on:click="onClickPhoneNumber(customer, number)"
            >
                Go
            </v-btn>
        </v-list-item>
    </div>

</v-container>

    <m-select-employee-endpoint-dialog
        :title="select_endpoint_title"
        ref="select-endpoint-dialog"
        v-on:select-endpoint="after_select_employee_endpoint"
    />
</m-pageframe>
</template>

<script>
// No imports needed

export default {
data() {
    return {
        customer: null,
        select_endpoint_title: null,
        after_select_employee_endpoint: () => {},
    }
},

mounted () {

    this.$rc.showSpinner();

    let params = {
            'organization_id' : this.$route.params.organization_id,
            'content_type' : 'commerce7',
            'customer_id' : this.$route.params.customer_id,
        };

    this.$rc.rest(
        'LIST: /api/v1/integrations/crm/customers-linkin',

        params,

        (data) => {
            this.$rc.hideSpinner();

            if ( data.results.length == 0 )
            {
                this.$rc.alert('Error','Unable to find commerce7 customer in RedChirp');
                return;
            }

            this.customer = data.results[0];

            if ( this.customer.customer_phone_numbers.length == 1 )
            {
                this.onClickPhoneNumber(this.customer, this.customer.customer_phone_numbers[0]);
            }
        },

        () => {
            this.$rc.hideSpinner();
            this.$rc.alert('Error','Unable to find commerce7 customer in RedChirp');
        },
    );
},

methods: {
    onClickPhoneNumber(item, number)
    {
        this.after_select_employee_endpoint = (employee_endpoint) => {
            let params = {
                'customer_id' : item.customer_id,
                'organization_id' : item.organization_id,
                'content_type' : 'commerce7',
                'customer_endpoint' : number,
                'employee_endpoint' : employee_endpoint
            };

            this.$rc.showSpinner();

            this.$rc.rest(
                'PUT: /api/v1/integrations/crm/customers/start-conversation',

                params,

                (data) => {
                    this.$rc.hideSpinner();

                    this.$router.push({
                        'name': 'home-routed',
                        'params' : data,
                        }).catch(()=>{}); // swallow any exception
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to start conversation');
                },
            );
        };

        this.select_endpoint_title = 'Select which RedChirp number to use when texting ' + (item.first_name || item.customer_name || this.$rc.pretty(number,'endpoint'));
        this.$refs['select-endpoint-dialog'].showDialog();
    },
},
}
</script>

<style lang="scss" scoped>
</style>